import React, { ReactElement, Fragment, ComponentType, Suspense } from 'react'
import { init, loadRemote } from '@module-federation/runtime'
import ReactDOM from 'react-dom'
import { User } from '../../../Permissions/AuthenticatedUser.context'
import { useEnsuredUser } from '../../../Permissions/useEnsuredUser'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../root.reducer'
import { CircularProgress } from 'beam'

interface RemoteAppProps {
  userContext: User,
  language: string,
  apiUrl: string | undefined,
}

export const SmartTagsApp = (): ReactElement => {
  const user = useEnsuredUser()
  const { i18n } = useTranslation()
  const appUrl = useAppSelector(state => state.app.appProperties?.convIntelligenceAppUrl)
  const apiUrl = useAppSelector(state => state.app.appProperties?.convIntelligenceApiUrl)

  let RemoteApp: never | ComponentType<RemoteAppProps> | null = null
  if (appUrl) {
    try {
      init({
        name: 'host',
        remotes: [
          {
            name: 'smartTag',
            alias: 'smartTag',
            entry: `${appUrl}/smartTag/assets/remoteEntry.js`,
            type: 'module',
          },
        ],
        shared: {
          react: {
            version: '17.0.2',
            scope: 'default',
            lib: () => React,
            shareConfig: {
              singleton: true,
              requiredVersion: '^17.0.0',
            },
          },
          'react-dom': {
            version: '17.0.2',
            scope: 'default',
            lib: () => ReactDOM,
            shareConfig: {
              singleton: true,
              requiredVersion: '^17.0.0',
            },
          },
        },
      })
    } catch (e) {
      // eslint-disable-next-line no-console -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
      console.error('Error initializing module federation', e)
    }

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Remove warning
    RemoteApp = React.lazy(() => loadRemote('smartTag/App') as Promise<{default: ComponentType<RemoteAppProps>}>)
  }

  return (
    <Fragment>
      <div style={{ height: '100%', backgroundColor: 'white' }}>
        <Suspense fallback={<div className='w-full h-full items-center justify-center flex'><CircularProgress size={56} /></div>}>
          {(RemoteApp) ? <RemoteApp userContext={user} language={i18n.language} apiUrl={apiUrl} /> : null}
        </Suspense>
      </div>
    </Fragment>
  )
}
